import { render, staticRenderFns } from "./LeaveCreate.vue?vue&type=template&id=4d4a4168"
import script from "@/controllers/custom/leave/leave-create?vue&type=script&lang=js&external"
export * from "@/controllers/custom/leave/leave-create?vue&type=script&lang=js&external"
import style0 from "./LeaveCreate.vue?vue&type=style&index=0&id=4d4a4168&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports